"use client";

import { useEffect, useState } from "react";

export function CookieConsent({
  onConsent,
}: {
  onConsent: (accepted: boolean) => void;
}) {
  const [showBanner, setShowBanner] = useState(false);
  const [isEU, setIsEU] = useState(false);

  useEffect(() => {
    // Check if user already made a choice
    const consent = localStorage.getItem("cookie-consent");
    if (consent) {
      onConsent(consent === "accepted");
      return;
    }

    // Check if user is in EU
    checkIfEU().then((inEU) => {
      setIsEU(inEU);
      if (inEU) {
        setShowBanner(true);
      } else {
        // Non-EU: auto-accept
        onConsent(true);
      }
    });
  }, [onConsent]);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setShowBanner(false);
    onConsent(true);
  };

  const handleDecline = () => {
    localStorage.setItem("cookie-consent", "declined");
    setShowBanner(false);
    onConsent(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[200] p-4 bg-slate-900 border-t border-slate-700 shadow-lg">
      <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-slate-300 text-center sm:text-left">
          We use cookies for analytics and to improve your experience.{" "}
          <a
            href="/privacy"
            className="text-blue-400 hover:underline"
          >
            Learn more
          </a>
        </p>
        <div className="flex gap-3">
          <button
            onClick={handleDecline}
            className="px-4 py-2 text-sm text-slate-400 hover:text-white transition-colors"
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            className="px-4 py-2 text-sm bg-blue-600 hover:bg-blue-500 text-white rounded-lg transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}

async function checkIfEU(): Promise<boolean> {
  try {
    const response = await fetch("/api/geo", {
      signal: AbortSignal.timeout(5000),
    });
    const data = await response.json();
    return data.isEU;
  } catch {
    // On error, assume non-EU (fail open for better UX)
    return false;
  }
}
